import React from 'react';
import { motion } from 'framer-motion';
interface LuxuryFrameProps {
  imageUrl: string;
  altText: string;
  caption?: string;
}
export function LuxuryFrame({
  imageUrl,
  altText,
  caption
}: LuxuryFrameProps) {
  return <motion.div className="relative flex flex-col items-center" animate={{
    y: [0, -8, 0]
  }} transition={{
    duration: 6,
    ease: 'easeInOut',
    repeat: Infinity
  }} data-id="element-235">
      <div className="relative" data-id="element-236">
        {/* Deep shadow with gold ambient glow */}
        <div className="absolute inset-0 bg-navy-rich/30 shadow-[0_30px_80px_-15px_rgba(0,0,0,0.6)] rounded-sm transform translate-y-6 translate-x-3" data-id="element-237"></div>
        <div className="absolute inset-0 bg-gold/10 blur-3xl rounded-sm transform translate-y-4" data-id="element-238"></div>

        {/* Outer thick gold border */}
        <div className="relative z-10 border-2 border-gold p-3 bg-navy-rich rounded-sm" data-id="element-239">
          {/* Inner thin gold-bright hairline border */}
          <div className="border border-gold-bright/60 p-2" data-id="element-240">
            {/* Image with subtle inner gold hairline */}
            <div className="border border-gold/30 rounded-sm overflow-hidden" data-id="element-241">
              <img src={imageUrl} alt={altText} className="w-full max-w-md object-cover block" data-id="element-242" />
            </div>
          </div>
        </div>

        {/* Large Gold Corner Bracket Accents */}
        {/* Top Left */}
        <div className="absolute -top-2 -left-2 w-16 h-16 border-t-2 border-l-2 border-gold z-20 pointer-events-none" data-id="element-243"></div>
        {/* Top Right */}
        <div className="absolute -top-2 -right-2 w-16 h-16 border-t-2 border-r-2 border-gold z-20 pointer-events-none" data-id="element-244"></div>
        {/* Bottom Left */}
        <div className="absolute -bottom-2 -left-2 w-16 h-16 border-b-2 border-l-2 border-gold z-20 pointer-events-none" data-id="element-245"></div>
        {/* Bottom Right */}
        <div className="absolute -bottom-2 -right-2 w-16 h-16 border-b-2 border-r-2 border-gold z-20 pointer-events-none" data-id="element-246"></div>

        {/* Decorative corner dots/diamonds */}
        <div className="absolute top-3 left-3 w-1.5 h-1.5 bg-gold rotate-45 z-20" data-id="element-247"></div>
        <div className="absolute top-3 right-3 w-1.5 h-1.5 bg-gold rotate-45 z-20" data-id="element-248"></div>
        <div className="absolute bottom-3 left-3 w-1.5 h-1.5 bg-gold rotate-45 z-20" data-id="element-249"></div>
        <div className="absolute bottom-3 right-3 w-1.5 h-1.5 bg-gold rotate-45 z-20" data-id="element-250"></div>
      </div>

      {caption && <div className="mt-8 flex flex-col items-center gap-3" data-id="element-251">
          <div className="w-12 h-px bg-gold/60" data-id="element-252"></div>
          <p className="font-serif italic uppercase text-gold text-sm tracking-[0.2em] font-medium" data-id="element-253">
            {caption}
          </p>
          <div className="w-12 h-px bg-gold/60" data-id="element-254"></div>
        </div>}
    </motion.div>;
}